// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__kP9vb","active":"Footer_active__K6c7l","MadeIn":"Footer_MadeIn__rMCu5","Link":"Footer_Link__FNJ8V"};